import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import   'rxjs/add/operator/map';
import { SistemaService } from '../services/sistema/sistema.service';
import { Observable } from 'rxjs';
import { Region, Country } from '../models/regions-shop.model';

@Injectable({
  providedIn: 'root'
})
export class RegionsShopService {
  url:string;
  regions:Region[] = [];

  constructor(private _sistemaService:SistemaService, private http:HttpClient) {
    this.url = _sistemaService.url;
  }


    getRegions(): Observable<Region[]> {

      return this.http.get(`${this.url}/regions`).map(this.extractRegion);

    }

    extractRegion(res:any) {
      this.regions = [];
      for (let i = 0; i < res.length; i++) {
        let tmp:Region = {
          _id:res[i]._id,
          lemaxId:res[i].lemaxId,
          title:res[i].title,
          allCountry:[],
          regionKeyCountry:[]
        }
        for (let j = 0; j < res[i].allCountry.length; j++) {
          let allCountry:Country = {
            _id:res[i].allCountry[j]._id,
            lemaxId:res[i].allCountry[j].lemaxId,
            name:res[i].allCountry[j].name,
            iso:res[i].allCountry[j].iso
          }
          tmp.allCountry.push(allCountry);
        }
        for (let j = 0; j < res[i].regionKeyCountry.length; j++) {
          let keyCountry:Country = {
            _id:res[i].regionKeyCountry[j]._id,
            lemaxId:res[i].regionKeyCountry[j].lemaxId,
            name:res[i].regionKeyCountry[j].name,
            iso:res[i].regionKeyCountry[j].iso
          }
          tmp.regionKeyCountry.push(keyCountry);
        }
        this.regions.push(tmp);
      }
      return this.regions;
    }

}
